const findByUrl = (url, array) => array.map(p => p.url).indexOf(url);

const findPathObject = (currentPath, array) => {
  const currentIndex = findByUrl(currentPath, array);
  return array[currentIndex] || {};
};

const nextPathObject = (currentPath, array) => {
  let nextIndex;
  const currentIndex = findByUrl(currentPath, array);
  nextIndex = currentIndex + 1;
  if (currentIndex === array.length - 1) {
    nextIndex = currentIndex;
  }
  return array[nextIndex];
};

const previousPathObject = (currentPath, array) => {
  let prevIndex;
  const currentIndex = findByUrl(currentPath, array);
  prevIndex = currentIndex - 1;
  if (currentIndex === 0) {
    prevIndex = currentIndex;
  }
  return array[prevIndex];
};

export { findByUrl, findPathObject, nextPathObject, previousPathObject };
